import * as React from 'react';
import * as styles from './modal.module.scss';
import { Button } from '@material-ui/core';
import UploadIcon from '../../../images/icons/upload-icon';
import { ButtonProps } from '@material-ui/core/Button';

/**
 * UploadFileButton
 * @function UploadFileButton - Button for uploading files
 */
const UploadFileButton = (props: ButtonProps) => {
  return (
    <Button className={styles.uploadButton} variant="outlined" {...props}>
      <UploadIcon color="#006da8" />
      Upload File
    </Button>
  );
};

export default UploadFileButton;
